import { lazy, Suspense } from 'react';
import ProtectedRoute from './protectedRoute';
import UnProtectedRoute from './unprotectedRoute';

import {
  createBrowserRouter,
  createRoutesFromElements,
  Outlet,
  Route,
} from 'react-router-dom';
import ResetOrSetPage from '../pages/ResetOrSetPage/resetOrSetPage';
import Path from '../constants/path';
import LeadDashboard from '../pages/LeadManagementPage/LeadDashboard/leadDashboard';
import ManageReassignment from '../pages/ManageReassignment/manageReassignment';
const Layout = lazy(() => import('../layouts/layout'));
const LogInPage = lazy(() => import('../pages/LoginPage/login'));
const RegisterOrReset = lazy(() =>
  import('../pages/RegisterOrResetPage/registerOrReset'),
);

const Errorpage = lazy(() => import('../pages/ErrorPage/errorPage'));
const InvalidUser = lazy(() => import('../pages/ErrorPage/invalidUser'));
const UnprotectedLayout = lazy(() =>
  import('../layouts/UnprotectedLayout/unProtectedLayout'),
);
const OtpPage = lazy(() => import('../pages/OtpPage/otpPage'));
const Reports = lazy(() => import('../pages/ReportsPage/ReportsPage'));
const LeadManagement = lazy(() =>
  import('../pages/LeadManagementPage/leadManagment'),
);
const LeadCreation = lazy(() =>
  import('../pages/LeadManagementPage/LeadAddCreation'),
);

import RedirectOnRefresh from './routeWrapper';

const ApiLogs = lazy(() => import('../pages/Logs/ApiLogs/ApiLogs'));
const WebhookLogs = lazy(() =>
  import('../pages/Logs/WebhookLogs/WebhookLogs'),
);
const Configuration = lazy(() =>
  import('../pages/Configuration/configuration'),
);
const LoanAppLog = lazy(() =>
  import('../pages/Logs/LoanApplicationLogs/LoanAppLog'),
);
const LoanAppLogDetailed = lazy(() =>
  import('../pages/Logs/LoanApplicationLogs/LoanAppLogDetailed'),
);
// const ManageReassignment = lazy(() =>
//   import('../pages/ManageReassignment/manageReassignment'),
// );
const ManageReassignmentDetail = lazy(() =>
  import('../pages/ManageReassignment/manageReassignmentDetail'),
);
const LoanSearch = lazy(() => import('../pages/LoanSearch/LoanSearch'));

const RoleMasters = lazy(() =>
  import('../pages/Masters/RoleMasters/RoleMasters'),
);
const BranchMasters = lazy(() =>
  import('../pages/Masters/BranchMasters/BranchMasters'),
);
const StateMaster = lazy(() =>
  import('../pages/Masters/StateMasters/StateMaster'),
);
const UserMaster = lazy(() => import('../pages/Masters/UserMaster/UserMaster'));

const LoanProductMaster = lazy(() =>
  import('../pages/Masters/LoanProductMaster/LoanProductmaster'),
);

const PincodeMaster = lazy(() =>
  import('../pages/Masters/PincodeMaster/PincodeMaster'),
);

const BankBranchMaster = lazy(() =>
  import('../pages/Masters/BankBranchMaster/BankBranchMaster'),
);

const RoleAndReportsMaster = lazy(() =>
  import('../pages/Masters/RoleAndReportsMaster/RoleAndReportsMaster'),
);
const BranchToProductMaster = lazy(() =>
  import('../pages/Masters/BranchToProductMaster/BranchToProductMaster'),
);
const CoLendingMaster = lazy(() =>
  import('../pages/Masters/CoLendingMaster/CoLendingMaster'),
);

const BranchToParallelWorkflow = lazy(() =>
  import('../pages/Masters/BranchToParallelWorkflow/BranchToParallelWorkflow'),
);

const PlatformReassignList = lazy(() =>
  import(
    '../pages/PlatformManagmentPage/PlatformDashboard/platformReassignList'
  ),
);
const Profile = lazy(() => import('../pages/ProfilePage/Profile'));
const OnHoldOrRejectApplication = lazy(() =>
  import('../pages/OnHoldOrRejectManagementPage/OnHoldOrRejectApplication'),
);
const DynamicFormRendering = lazy(() =>
  import(
    '../pages/LoanApplicationsPage/LoanApplicationsDashboard/OtherLoanApplicationStages/DynamicFormRendering'
  ),
);
const LoanApplications = lazy(() =>
  import(
    '../pages/LoanApplicationsPage/LoanApplicationsDashboard/Applications/loanApplications'
  ),
);
const QDEApplication = lazy(() =>
  import(
    '../pages/LoanApplicationsPage/LoanApplicationsDashboard/QDE/QDEApplication'
  ),
);
const LoanDashboard = lazy(() =>
  import(
    '../pages/LoanApplicationsPage/LoanApplicationsDashboard/Dashboard/loanDashboard'
  ),
);
const PlatformDashboard = lazy(() =>
  import('../pages/PlatformManagmentPage/PlatformDashboard/platformDashboard'),
);
const MccDashboard = lazy(() =>
  import('../pages/MccManagmentPage/MccDashboard/mccDashboard'),
);
const PlatformManagement = lazy(() =>
  import('../pages/PlatformManagmentPage/PlatformDashboard/platformManagement'),
);
const MccManagement = lazy(() =>
  import('../pages/MccManagmentPage/MccDashboard/mccManagement'),
);
const PlatformAddCreation = lazy(() =>
  import('../pages/PlatformManagmentPage/platformAddCreation'),
);
const MccAddCreation = lazy(() =>
  import('../pages/MccManagmentPage/mccAddCreation'),
);
const Notification = lazy(() =>
  import('../pages/NotificationPage/Notification'),
);
const RolePermissionMaster = lazy(() =>
  import('../pages/Masters/RoleMasters/RolePermissionMaster'),
);
import { CircularProgress } from '@mui/material';
import TemplateEngine from '../pages/TemplateEngine/TemplateEngine';
import ConsumerDurableMaster from '../pages/Masters/ConsumerDurableMaster/ConsumerDurableMaster';
import DairyMaster from '../pages/Masters/DairyMaster/DairyMaster';
import EStampMaster from '../pages/Masters/EStampMaster/EStampMaster';
import DropdownMaster from '../pages/Masters/DropdownMaster/DropdownMaster';
import EmailTemplateMaster from '../pages/Masters/EmailTemplateMaster/EmailTemplateMaster';
import EmailTemplate from '../pages/TemplateEngine/EmailTemplate';
const CustomerProfile = lazy(() =>
  import('../pages/Customer360Page/CustomerProfile/customerProfile'),
);
const Customer360Page = lazy(() =>
  import('../pages/Customer360Page/customer360Page'),
);
const LoanAccDetails = lazy(() =>
  import('../pages/Customer360Page/CustomerProfile/LoanDetails/loanAccDetails'),
);

const LoadingFallback = () => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
    }}>
    <CircularProgress />
  </div>
);
const ProtectedLayout = RedirectOnRefresh(Layout);
const UnprotectedLayoutNew = RedirectOnRefresh(UnprotectedLayout);

const Routers = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route
        element={
          <Suspense fallback={<LoadingFallback />}>
            <UnProtectedRoute element={<UnprotectedLayoutNew />} />
          </Suspense>
        }>
        <Route path={Path.login} element={<LogInPage />} />
        <Route path={Path.register} element={<RegisterOrReset />} />
        <Route path={Path.forgot_password} element={<RegisterOrReset />} />
        <Route path={Path.otp} element={<OtpPage />} />
        <Route path={Path.reset_password} element={<ResetOrSetPage />} />
        <Route path={Path.set_password} element={<ResetOrSetPage />} />
      </Route>

      <Route
        path="/"
        element={
          <Suspense fallback={<LoadingFallback />}>
            <ProtectedRoute element={<ProtectedLayout />} />
          </Suspense>
        }>
        <Route
          path="lead-management"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <Outlet />
            </Suspense>
          }>
          <Route index element={<LeadDashboard />} />
          <Route path="lead" element={<Outlet />}>
            <Route index element={<LeadManagement />} />
            <Route path="lead-details" element={<LeadCreation />} />
          </Route>
        </Route>
        <Route
          path="platform-management"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <Outlet />
            </Suspense>
          }>
          <Route index element={<PlatformDashboard />} />
          <Route path="platform" element={<Outlet />}>
            <Route index element={<PlatformReassignList />} />
            <Route path="platform-view" element={<PlatformManagement />} />
            <Route path="platform-details" element={<PlatformAddCreation />} />
          </Route>
        </Route>
        <Route
          path="mcc-management"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <Outlet />
            </Suspense>
          }>
          <Route index element={<MccDashboard />} />
          <Route path="mcc" element={<Outlet />}>
            <Route index element={<MccManagement />} />
            <Route path="mcc-details" element={<MccAddCreation />} />
          </Route>
        </Route>
        <Route
          path="loan-application"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <Outlet />
            </Suspense>
          }>
          <Route index element={<LoanApplications />} />
          <Route path="qde" element={<Outlet />}>
            <Route index element={<LoanDashboard />} />
            <Route path="applicants" element={<QDEApplication />} />
          </Route>
          <Route path="dde" element={<Outlet />}>
            <Route index element={<LoanDashboard />} />
            <Route path="applicants" element={<DynamicFormRendering />} />
          </Route>
          <Route path="field-investigation" element={<Outlet />}>
            <Route index element={<LoanDashboard />} />
            <Route path="applicants" element={<DynamicFormRendering />} />
          </Route>
          <Route path="review-fi" element={<Outlet />}>
            <Route index element={<LoanDashboard />} />
            <Route path="applicants" element={<DynamicFormRendering />} />
          </Route>
          <Route path="personal-discussion" element={<Outlet />}>
            <Route index element={<LoanDashboard />} />
            <Route path="applicants" element={<DynamicFormRendering />} />
          </Route>
          <Route path="fraud-control-unit" element={<Outlet />}>
            <Route index element={<LoanDashboard />} />
            <Route path="applicants" element={<DynamicFormRendering />} />
          </Route>
          <Route path="secondary-review" element={<Outlet />}>
            <Route index element={<LoanDashboard />} />
            <Route path="applicants" element={<DynamicFormRendering />} />
          </Route>

          <Route path="legal-review" element={<Outlet />}>
            <Route index element={<LoanDashboard />} />
            <Route path="applicants" element={<DynamicFormRendering />} />
          </Route>
          <Route path="property-valuer" element={<Outlet />}>
            <Route index element={<LoanDashboard />} />
            <Route path="applicants" element={<DynamicFormRendering />} />
          </Route>
          <Route path="sanction" element={<Outlet />}>
            <Route index element={<LoanDashboard />} />
            <Route path="applicants" element={<DynamicFormRendering />} />
          </Route>
          <Route path="deviation-approval" element={<Outlet />}>
            <Route index element={<LoanDashboard />} />
            <Route path="applicants" element={<DynamicFormRendering />} />
          </Route>

          <Route path="conversation" element={<Outlet />}>
            <Route index element={<LoanDashboard />} />
            <Route path="applicants" element={<DynamicFormRendering />} />
          </Route>
          <Route path="order-confirmation" element={<Outlet />}>
            <Route index element={<LoanDashboard />} />
            <Route path="applicants" element={<DynamicFormRendering />} />
          </Route>
          <Route path="co-lending" element={<Outlet />}>
            <Route index element={<LoanDashboard />} />
            <Route path="applicants" element={<DynamicFormRendering />} />
          </Route>

          <Route path="onhold" element={<Outlet />}>
            <Route index element={<LoanDashboard />} />
            <Route path="applicants" element={<OnHoldOrRejectApplication />} />
          </Route>
          <Route path="rejected-applications" element={<Outlet />}>
            <Route index element={<LoanDashboard />} />
            <Route path="applicants" element={<OnHoldOrRejectApplication />} />
          </Route>
          <Route path="eligibilty-check" element={<Outlet />}>
            <Route index element={<LoanDashboard />} />
            <Route path="applicants" element={<DynamicFormRendering />} />
          </Route>
          <Route path="approval-flow" element={<Outlet />}>
            <Route index element={<LoanDashboard />} />
            <Route path="applicants" element={<DynamicFormRendering />} />
          </Route>
          <Route path="loan-booking" element={<Outlet />}>
            <Route index element={<LoanDashboard />} />
            <Route path="applicants" element={<DynamicFormRendering />} />
          </Route>
          <Route path="document-esign" element={<Outlet />}>
            <Route index element={<LoanDashboard />} />
            <Route path="applicants" element={<DynamicFormRendering />} />
          </Route>
          <Route path="document-verification" element={<Outlet />}>
            <Route index element={<LoanDashboard />} />
            <Route path="applicants" element={<DynamicFormRendering />} />
          </Route>
          <Route path="partner-approval" element={<Outlet />}>
            <Route index element={<LoanDashboard />} />
            <Route path="applicants" element={<DynamicFormRendering />} />
          </Route>
          <Route path="pending-partner-update" element={<Outlet />}>
            <Route index element={<LoanDashboard />} />
            <Route path="applicants" element={<DynamicFormRendering />} />
          </Route>
          <Route path="disbursement" element={<Outlet />}>
            <Route index element={<LoanDashboard />} />
            <Route path="applicants" element={<DynamicFormRendering />} />
          </Route>
          <Route path="tranche-disbursement" element={<Outlet />}>
            <Route index element={<LoanDashboard />} />
            <Route path="applicants" element={<DynamicFormRendering />} />
          </Route>
          <Route path="tranche-verification" element={<Outlet />}>
            <Route index element={<LoanDashboard />} />
            <Route path="applicants" element={<DynamicFormRendering />} />
          </Route>
          <Route path="tranche-execution" element={<Outlet />}>
            <Route index element={<LoanDashboard />} />
            <Route path="applicants" element={<DynamicFormRendering />} />
          </Route>
        </Route>
        <Route
          path="loan-search"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <Outlet />
            </Suspense>
          }>
          <Route index element={<LoanSearch />} />

          <Route path="loan-detailed-view" element={<Outlet />}>
            <Route index element={<OnHoldOrRejectApplication />} />
          </Route>
        </Route>

        <Route path="profile" element={<Outlet />}>
          <Route index element={<Profile />} />
        </Route>
        <Route
          path="masters"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <Outlet />
            </Suspense>
          }>
          <Route index element={<RoleMasters />} />
          <Route
            path="role-master"
            element={
              <Suspense fallback={<LoadingFallback />}>
                <Outlet />
              </Suspense>
            }>
            <Route index element={<RoleMasters />} />
            <Route path="permissions" element={<RolePermissionMaster />} />
          </Route>
          <Route path="branch-master" element={<BranchMasters />} />
          <Route path="state-master" element={<StateMaster />} />
          <Route path="user-master" element={<UserMaster />} />
          <Route path="loan-product-master" element={<LoanProductMaster />} />
          <Route path="pincode-master" element={<PincodeMaster />} />
          <Route path="bank-branch-master" element={<BankBranchMaster />} />
          <Route
            path="role-reports-master"
            element={<RoleAndReportsMaster />}
          />
          <Route
            path="branch-to-product-master"
            element={<BranchToProductMaster />}
          />
          <Route path="co-lending-master" element={<CoLendingMaster />} />
          <Route
            path="consumer-durable-master"
            element={<ConsumerDurableMaster />}
          />
          <Route path="dairy-master" element={<DairyMaster />} />
          <Route path="email-template-master" element={<EmailTemplateMaster />} />
          <Route path="e-stamp-master" element={<EStampMaster />} />
          <Route path="dropdown-master" element={<DropdownMaster />} />
          <Route path="branch-to-parallel-workflow" element={<BranchToParallelWorkflow />} />
        </Route>
        <Route
          path="logs/api-log"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <Outlet />
            </Suspense>
          }>
          <Route index element={<ApiLogs />} />
        </Route>

        <Route
          path="logs/webhook-log"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <Outlet />
            </Suspense>
          }>
          <Route index element={<WebhookLogs />} />
        </Route>

        <Route
          path="logs/loan-application-log"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <Outlet />
            </Suspense>
          }>
          <Route index element={<LoanAppLog />} />
          <Route path="details" element={<LoanAppLogDetailed />} />
        </Route>
        <Route
          path="manage-reassignment"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <Outlet />
            </Suspense>
          }>
          <Route index element={<ManageReassignment />} />
          <Route path="detailed-view" element={<ManageReassignmentDetail />} />
        </Route>
        <Route
          path="configuration"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <Outlet />
            </Suspense>
          }>
          <Route index element={<Configuration />} />
        </Route>
        <Route
          path="reports"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <Outlet />
            </Suspense>
          }>
          <Route index element={<Reports />} />
        </Route>
        <Route
          path="notification"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <Outlet />
            </Suspense>
          }>
          <Route index element={<Notification />} />
        </Route>
        <Route
          path="customer-360"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <Outlet />
            </Suspense>
          }>
          <Route index element={<Customer360Page />} />
          <Route path="customer-profile" element={<Outlet />}>
            <Route index element={<CustomerProfile />} />
            <Route path="loan-account-details" element={<LoanAccDetails />} />
          </Route>
        </Route>

        <Route
          path="template-engine"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <Outlet />
            </Suspense>
          }>
          <Route index element={<TemplateEngine />} />
          <Route path="email-template" element={<EmailTemplate />} />
        </Route>
      </Route>
      <Route
        path={Path.invalid_user}
        element={
          <Suspense fallback={<LoadingFallback />}>
            <InvalidUser />
          </Suspense>
        }
      />
      <Route
        path="*"
        element={
          <Suspense fallback={<LoadingFallback />}>
            <Errorpage />
          </Suspense>
        }></Route>
    </>,
  ),
);
export default Routers;
